import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '../views/layout/Layout'

export const constantRoutes = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },

  {
    path: '',
    component: Layout,
    redirect: 'dashboard',
    name: 'Dashboard',
    meta: { title: 'Dashboard', icon: 'Dashboard' },
    children: [{
      path: 'dashboard',
      component: () => import('@/views/dashboard/index')
    }]
  }
]

export const asyncRoutes = [
  {
    path: '/SystemManage',
    alwaysShow: true,
    component: Layout,
    redirect: '/SystemManage',
    name: 'SystemManage',
    meta: { title: 'System Manage', icon: 'management', actionid: 1 },
    children: [{
      path: 'SystemUser',
      component: () => import('@/views/systemmanage/system-user'),
      name: 'SystemUser',
      meta: { title: 'System User', icon: 'user-line', actionid: 11 }
    },

    {
      path: 'SystemUserRight',
      component: () => import('@/views/systemmanage/system-user-right'),
      name: 'SystemUserRight',
      meta: { title: 'System User Rights', icon: 'tree', actionid: 12 }
    },

    {
      path: 'SystemUserLoginInfo',
      component: () => import('@/views/systemmanage/system-user-login-info'),
      name: 'SystemUserRight',
      meta: { title: 'System User Login Info', icon: 'tree', actionid: 14 }
    }]
  },
  {
    path: '/Approval',
    alwaysShow: true,
    component: Layout,
    redirect: '/Approval',
    name: 'Approval',
    meta: { title: 'Cash Flow', icon: 'management', actionid: 111113 },
    children: [
      {
        path: 'Finance',
        component: () => import('@/views/approval/index'),
        name: 'Finance',
        meta: { title: 'Finance', icon: 'company', actionid: 1111131 },
        children: [
          {
            path: 'Reimbursement',
            component: () => import('@/views/approval/reimbursement'),
            name: 'Reimbursement',
            meta: { title: 'Reimbursement', icon: 'company', actionid: 11111311 }
          },
          {
            path: 'CashRequirement',
            component: () => import('@/views/approval/cashRequirement'),
            name: 'CashRequirement',
            meta: { title: 'Cash Requirement', icon: 'company', actionid: 11111312 }
          },
          {
            path: 'Statement',
            component: () => import('@/views/approval/bill'),
            name: 'Statement',
            meta: { title: 'Statement', icon: 'edit', actionid: 11111313 }
          }
        ]
      },
      {
        path: 'Trade Payment',
        component: () => import('@/views/approval/index'),
        name: 'Trade Payment',
        meta: { title: 'Trade Payment', icon: 'company', actionid: 1111132 },
        children: [
          {
            path: 'Customer',
            component: () => import('@/views/trademanage/customer'),
            name: 'Customer',
            meta: { title: 'Customer', icon: 'user', actionid: 11111321 }
          },
          {
            path: 'Contract',
            component: () => import('@/views/trademanage/contract'),
            name: 'Contract',
            meta: { title: 'Contract', icon: 'edit', actionid: 11111322 }
          }
        ]
      }
    ]
  },

  {
    path: '/ColinNotes',
    // alwaysShow: true,
    component: Layout,
    redirect: '/ColinNotes',
    name: 'ColinNotes',
    meta: { title: 'Colin Notes', icon: 'management', actionid: 10 },
    children: [{
      path: 'ColinNotes',
      component: () => import('@/views/colinnotes/index'),
      name: 'SystemUser',
      meta: { title: 'Colin Notes', icon: 'user-line', actionid: 10 }
    }]
  },

  {
    path: '/BTCNews',
    alwaysShow: true,
    component: Layout,
    redirect: '/BTCNews',
    name: 'BTCNews',
    meta: { title: 'BTC Info', icon: 'news', actionid: 2 },
    children: [{
      path: 'BTCNewsBeef',
      component: () => import('@/views/btcnews/index'),
      name: 'BTCNewsBeef',
      meta: { title: 'BTCNews -- BTC', icon: 'news', actionid: 21 },
      children: [{
        path: 'CNVersion',
        component: () => import('@/views/btcnews/index'),
        name: 'beef',
        meta: { title: 'CN Version', icon: 'language', actionid: 211 }
      },

      {
        path: 'ENVersion',
        component: () => import('@/views/btcnews/index'),
        name: 'beefEn',
        meta: { title: 'EN Version', icon: 'language', actionid: 212 }
      },

      {
        path: 'OtherVersion',
        component: () => import('@/views/btcnews/index'),
        name: 'beefOther',
        meta: { title: 'Other Version', icon: 'language', actionid: 212 }
      }]
    },

    {
      path: 'BTCNewsPork',
      component: () => import('@/views/btcnews/index'),
      name: 'pork',
      meta: { title: 'BTCNews -- PTC', icon: 'news', actionid: 22 },
      children: [{
        path: 'CNVersion',
        component: () => import('@/views/btcnews/index'),
        name: 'porkCN',
        meta: { title: 'CN Version', icon: 'language', actionid: 22 }
      },

      {
        path: 'ENVersion',
        component: () => import('@/views/btcnews/index'),
        name: 'porkEn',
        meta: { title: 'EN Version', icon: 'language', actionid: 22 }
      }]
    }]
  },

  {
    path: '/BtcData',
    alwaysShow: true,
    component: Layout,
    redirect: '/BtcData',
    name: 'BtcData',
    meta: { title: 'BTC Data', icon: 'management', actionid: 9 },
    children: [
      {
        path: 'BeefDataManage',
        component: () => import('@/views/btcdata/beef/index'),
        name: 'BeefDataManage',
        meta: { title: 'Beef Data Manage', icon: 'management', actionid: 91 }
      },
      {
        path: 'PorkDataManage',
        component: () => import('@/views/btcdata/pork/index'),
        name: 'PorkDataManage',
        meta: { title: 'Pork Data Manage', icon: 'management', actionid: 92 }
      },
      {
        path: 'BeefDataCountry',
        component: () => import('@/views/btcdata/country/index'),
        name: 'BeefDataCountry',
        meta: { title: 'Beef Data Country', icon: 'management', actionid: 93 }
      }
    ]
  },

  {
    path: '/PriceManage',
    alwaysShow: true,
    component: Layout,
    redirect: '/userprice/index',
    name: 'PriceManage',
    meta: { title: 'BTC Price', icon: 'edit', actionid: 6 },
    children: [
      // {
      //   path: 'index',
      //   component: () => import('@/views/btcprice/index'),
      //   name: 'MarketPrice',
      //   meta: { title: 'Market Price', icon: 'edit', actionid: 41 }
      // },

      {
        path: 'MarketIndex',
        component: () => import('@/views/appmanage/marketindex'),
        name: 'MarketIndex',
        meta: { title: 'Market Index', icon: 'management', actionid: 61 }
      },

      {
        path: 'MarketReport',
        component: () => import('@/views/appmanage/marketreport'),
        name: 'MarketReport',
        meta: { title: 'Market Report', icon: 'management', actionid: 62 }
      },
          
      {
        path: 'MarketPriceDataIndex',
        component: () => import('@/views/appmanage/marketpricedataindex'),
        name: 'Price Index',
        meta: { title: 'Price Index', icon: 'management', actionid: 66 }
      },

      {
        path: 'MarketPriceDataResearch',
        component: () => import('@/views/appmanage/marketpricedataresearch'),
        name: 'Est. Price',
        meta: { title: 'Est. Price', icon: 'management', actionid: 67 }
      },

      {
        path: 'MarketNewImportExportData',
        component: () => import('@/views/appmanage/marketnewimportexportdata'),
        name: 'New Export Data',
        meta: { title: 'New Export Data', icon: 'management', actionid: 68 }
      },

      {
        path: 'MarketEstPatterns',
        component: () => import('@/views/appmanage/marketestpatterns'),
        name: 'Est. Patterns',
        meta: { title: 'Est. Patterns', icon: 'management', actionid: 69 }
      },

      {
        path: 'MarketReportEn',
        component: () => import('@/views/appmanage/marketreporten'),
        name: 'MarketReportEn',
        meta: { title: 'Market Report En', icon: 'management', actionid: 62 }
      },

      {
        path: 'MarketReportOther',
        component: () => import('@/views/appmanage/marketreportother'),
        name: 'MarketReportOther',
        meta: { title: 'Market Report Other', icon: 'management', actionid: 62 }
      },

      {
        path: 'MarketPrice',
        component: () => import('@/views/btcprice/user-final-price'),
        name: 'MarketPrice',
        meta: { title: 'Market Price', icon: 'edit', actionid: 63 }
      },

      {
        path: 'MarketPriceDict',
        component: () => import('@/views/btcmarket/price-dictionary'),
        name: 'MarketPriceDict',
        meta: { title: 'Market Price Dictionary', icon: 'edit', actionid: 63 }
      },

      {
        path: 'FuturesMarketData',
        component: () => import('@/views/appmanage/futuresmarketdata'),
        name: 'FuturesMarketData',
        meta: { title: 'Futures Market Data Manage', icon: 'management', actionid: 64 }
      },

      {
        path: 'SpotMarketData',
        component: () => import('@/views/appmanage/spotmarketdata'),
        name: 'SpotMarketData',
        meta: { title: 'Spot Market Data Manage', icon: 'management', actionid: 65 }
      },

      {
        path: 'UserFeedback',
        component: () => import('@/views/btcprice/user-feedback'),
        name: 'UserFeedback',
        meta: { title: 'User Feedback', icon: 'management', actionid: 885 }
      }
    ]
  },

  {
    path: '/CompanySection',
    alwaysShow: true,
    component: Layout,
    redirect: '/CompanySection',
    name: 'CompanySection',
    meta: { title: 'Company', icon: 'company', actionid: 3 },
    children: [{
      path: 'Company',
      component: () => import('@/views/company/company'),
      name: 'Company',
      meta: { title: 'Company', icon: 'company', actionid: 31 }
    },
    {
      path: 'CompanySales',
      component: () => import('@/views/company/companysales'),
      name: 'CompanySales',
      meta: { title: 'Sales Company', icon: 'user-line', actionid: 884 }
    },
    {
      path: 'SalesUserLoginInfo',
      component: () => import('@/views/company/sales-user-login-info'),
      name: 'Sales User Login Info',
      meta: { title: 'Sales User Login Info', icon: 'user-line', actionid: 885 }
    },
    {
      path: 'SalesCompanyUpdateRecord',
      component: () => import('@/views/company/sales-company-update-record'),
      name: 'Sales Company Update Record',
      meta: { title: 'Sales Company Update Record', icon: 'user-line', actionid: 886 }
    },
    {
      path: 'CompanyCRM',
      component: () => import('@/views/company/company-crm'),
      name: 'CompanyCRM',
      meta: { title: 'Company CRM', icon: 'user-line', actionid: 37 }
    },
    {
      path: 'UserLoginInfo',
      component: () => import('@/views/company/user-login-info'),
      name: 'UserLoginInfo',
      meta: { title: 'User Login Info', icon: 'user-line', actionid: 32 }
    },

    {
      path: 'UserLoginGroupInfo',
      component: () => import('@/views/company/user-login-group-info'),
      name: 'UserLoginGroupInfo',
      meta: { title: 'User Login Group Info', icon: 'group', actionid: 33 }
    },

    {
      path: 'CompanyUpdateRecord',
      component: () => import('@/views/company/company-update-record'),
      name: 'CompanyUpdateRecord',
      meta: { title: 'Company Update Record', icon: 'edit', actionid: 38 }
    },
    {
      path: 'CompanyPrivacy',
      component: () => import('@/views/company/company-privacy'),
      name: 'CompanyPrivacy',
      meta: { title: 'Company Privacy', icon: 'user-line', actionid: 40 }
    },

    {
      path: 'UserMembershipRequest',
      component: () => import('@/views/company/user-membership-request'),
      name: 'UserMembershipRequest',
      meta: { title: 'User Membership Request', icon: 'member', actionid: 34 },
      children: [{
        path: 'DomesticUsers',
        component: () => import('@/views/company/user-membership-request'),
        name: 'DomesticUsersRequest',
        meta: { title: 'Chinese Users', icon: 'user', actionid: 341 }
      },
      {
        path: 'SalesDomesticUsers',
        component: () => import('@/views/company/sales-user-membership-request'),
        name: 'SalesDomesticUsersRequest',
        meta: { title: 'SalesChinese Users', icon: 'user', actionid: 887 }
      },
      {
        path: 'ForeignUsers',
        component: () => import('@/views/company/user-membership-request'),
        name: 'ForeignUsersRequest',
        meta: { title: 'Foreign Users', icon: 'user', actionid: 342 }
      }]
    },

    {
      path: 'UserMemberList',
      component: () => import('@/views/company/user-member-list'),
      name: 'UserMemberList',
      meta: { title: 'User Member List', icon: 'userlist', actionid: 35 },
      children: [{
        path: 'DomesticUsers',
        component: () => import('@/views/company/user-member-list'),
        name: 'DomesticUsers',
        meta: { title: 'Chinese Users', icon: 'user', actionid: 351 }
      },
      {
        path: 'ForeignUsers',
        component: () => import('@/views/company/user-member-list'),
        name: 'ForeignUsers',
        meta: { title: 'Foreign Users', icon: 'user', actionid: 352 }
      }]
    },

    {
      path: 'BTCMembership',
      component: () => import('@/views/company/btc-membership-index'),
      name: 'BTCMembership',
      meta: { title: 'BTC Membership', icon: 'user-line', actionid: 36 },
      children: [
        {
          path: 'BTCMembershipNew',
          component: () => import('@/views/company/btc-membership-new'),
          name: 'BTCMembershipNew',
          meta: { title: 'BTC Membership New', icon: 'user', actionid: 363 }
        },
        {
          path: 'ChineseVersion',
          component: () => import('@/views/company/btc-membership'),
          name: 'ChineseVersion',
          meta: { title: 'Chinese Version', icon: 'user', actionid: 361 }
        },
        {
          path: 'EnglishVersion',
          component: () => import('@/views/company/btc-membership'),
          name: 'EnglishVersion',
          meta: { title: 'English Version', icon: 'user', actionid: 362 }
        }
      ]
    },
    {
      path: 'CompanyTrends',
      component: () => import('@/views/beeftrends'),
      name: 'CompanyTrends',
      meta: { title: 'Company Trends', icon: 'user-line', actionid: 39 }
    }]
  },

  {
    path: '/BDNoteSection',
    alwaysShow: true,
    component: Layout,
    redirect: '/BDNoteSection',
    name: 'BDNoteSection',
    meta: { title: 'BD Notes', icon: 'edit', actionid: 4 },
    children: [{
      path: 'BDNotes',
      component: () => import('@/views/bdnotes/index'),
      name: 'BDNotes',
      meta: { title: 'BD Notes', icon: 'edit', actionid: 41 }
    }]
  },

  {
    path: '/Trade',
    alwaysShow: true,
    component: Layout,
    redirect: '/Trade',
    name: 'Trade',
    meta: { title: 'BTC Market', icon: 'management', actionid: 8 },
    children: [
      {
        path: 'OfferManage',
        component: () => import('@/views/btctrade/offer-manage'),
        name: 'OfferManage',
        meta: { title: 'Offer Manage', icon: 'management', actionid: 81 }
      },
      {
        path: 'Suppliers',
        component: () => import('@/views/btctrade/company-customs'),
        name: 'Suppliers',
        meta: { title: 'Suppliers', icon: 'management', actionid: 83 }
      },
      // {
      //   path: 'SmartPushData',
      //   component: () => import('@/views/btctrade/smart-push-data'),
      //   name: 'SmartPushData',
      //   meta: { title: 'Smart Push Data', icon: 'management', actionid: 82 }
      // },
      // {
      //   path: 'CustomsData',
      //   component: () => import('@/views/btctrade/customs-data'),
      //   name: 'CustomsData',
      //   meta: { title: 'Customs Data', icon: 'management', actionid: 84 }
      // },
      {
        path: 'FuturesManage',
        component: () => import('@/views/btctrade/futures/futures-manage'),
        name: 'FuturesManage',
        meta: { title: 'Futures Manage', icon: 'management', actionid: 85 }
      },
      {
        path: 'CirclesManage',
        component: () => import('@/views/btctrade/circles-manage'),
        name: 'CirclesManage',
        meta: { title: 'Circles Manage', icon: 'management', actionid: 86 }
      },
      {
        path: 'ChatManage',
        component: () => import('@/views/btctrade/chat-manage'),
        name: 'ChatManage',
        meta: { title: 'Chat Manage', icon: 'management', actionid: 88 }
      },
      {
        path: 'CutsResearchManage',
        component: () => import('@/views/beefcuts/index'),
        name: 'CutsResearchManage',
        meta: { title: 'Cuts Research Manage', icon: 'management', actionid: 87 }
      },
      {
        path: 'CircleRecordManage',
        component: () => import('@/views/btctrade/circleRecord-manage'),
        name: 'CircleRecordManage',
        meta: { title: 'CircleRecord Manage', icon: 'group', actionid: 89 }
      }
    ]
  },

  {
    path: '/Financial',
    alwaysShow: true,
    component: Layout,
    redirect: '/Financial',
    name: 'Financial',
    meta: { title: 'Futures Financial', icon: 'management', actionid: 111111 },
    children: [
      {
        path: 'Appeal',
        component: () => import('@/views/financial/appeal-agency'),
        name: 'Appeal',
        meta: { title: 'Appeal', icon: 'company', actionid: 1111111 }
      },
      {
        path: 'Agency',
        component: () => import('@/views/financial/appeal-agency'),
        name: 'Agency',
        meta: { title: 'Agency', icon: 'company', actionid: 1111112 }
      },
      {
        path: 'Aggregate',
        component: () => import('@/views/financial/aggregate'),
        name: 'Aggregate',
        meta: { title: 'Aggregate', icon: 'company', actionid: 1111113 }
      }
    ]
  },

  {
    path: '/PurchaseAndSale',
    alwaysShow: true,
    component: Layout,
    redirect: '/PurchaseAndSale',
    name: 'PurchaseAndSale',
    meta: { title: 'Spot Trade', icon: 'management', actionid: 111112 },
    children: [
      {
        path: 'Purchase',
        component: () => import('@/views/purchaseSale/appeal-agency'),
        name: 'Purchase',
        meta: { title: 'Purchase', icon: 'company', actionid: 1111121 }
      },
      {
        path: 'Sale',
        component: () => import('@/views/purchaseSale/appeal-agency'),
        name: 'Sale',
        meta: { title: 'Sale', icon: 'company', actionid: 1111122 }
      },
      {
        path: 'Aggregate',
        component: () => import('@/views/purchaseSale/aggregate'),
        name: 'Aggregate',
        meta: { title: 'Aggregate', icon: 'company', actionid: 1111123 }
      }
    ]
  },

  {
    path: '/Retail',
    alwaysShow: true,
    component: Layout,
    redirect: '/BDNoteSection/index',
    name: 'Retail',
    meta: { title: 'C-Trial', icon: 'edit', actionid: 5 },
    children: [{
      path: 'index',
      component: () => import('@/views/retail/retail-index'),
      name: 'RetailIndex',
      meta: { title: 'C-Trial Data Manage', icon: 'edit', actionid: 51 }
    }]
  },

  {
    path: '/AppManage',
    alwaysShow: true,
    component: Layout,
    redirect: '/AppManage',
    name: 'AppManage',
    meta: { title: 'App Manage', icon: 'management', actionid: 7 },
    children: [
      {
        path: 'AppUpdate',
        component: () => import('@/views/appmanage/appupdate'),
        name: 'AppUpdate',
        meta: { title: 'App Update', icon: 'management', actionid: 71 }
      },
      {
        path: 'Setting',
        component: () => import('@/views/appmanage/setting'),
        name: 'Setting',
        meta: { title: 'Setting', icon: 'management', actionid: 72 }
      },
      {
        path: 'Advertisement',
        component: () => import('@/views/appmanage/advertisement'),
        name: 'Advertisement',
        meta: { title: 'Advertisement', icon: 'management', actionid: 73 }
      }
      // ,
      // {
      //   path: 'CommentManage',
      //   component: () => import('@/views/appmanage/newscomment'),
      //   name: 'CommentManage',
      //   meta: { title: 'Comment Manage', icon: 'management' }
      // },

      // {
      //   path: 'RoleManage',
      //   component: () => import('@/views/appmanage/rolemanage'),
      //   name: 'RoleManage',
      //   meta: { title: 'Role Manage', icon: 'management', actionid: 71 }
      // },

      // {
      //   path: 'OrderManage',
      //   component: () => import('@/views/appmanage/trademanage/order-review'),
      //   name: 'OrderManage',
      //   meta: { title: 'Order Manage', icon: 'management', actionid: 71 }
      // },

      // {
      //   path: 'OrderMatch',
      //   component: () => import('@/views/appmanage/trademanage/order-match'),
      //   name: 'OrderMatch',
      //   meta: { title: 'Order Match', icon: 'management', actionid: 71 }
      // },

      // {
      //   path: 'CustomsData',
      //   component: () => import('@/views/appmanage/customsdata'),
      //   name: 'CustomsData',
      //   meta: { title: 'Customs Data', icon: 'management', actionid: 71 }
      // }
    ]
  },

  {
    path: '/BtcEst',
    alwaysShow: true,
    component: Layout,
    redirect: '/BtcEst',
    name: 'BtcEst',
    meta: { title: 'BTC Est', icon: 'management', actionid: 222222 },
    children: [
      {
        path: 'BtcEstSearchStatistics',
        component: () => import('@/views/btcest/index'),
        name: 'BtcEstSearchStatistics',
        meta: { title: 'BTC Est Search Statistics', icon: 'management', actionid: 2222221 }
      },
      {
        path: 'BtcEstStateManage',
        component: () => import('@/views/btcest/manage/est-manage'),
        name: 'BtcEstStateManage',
        meta: { title: 'BTC Est State Manage', icon: 'management', actionid: 2222222 }
      }
    ]
  },

  {
    path: '/BtcMarketTrade',
    alwaysShow: true,
    component: Layout,
    redirect: '/BtcMarketTrade',
    name: 'BtcMarketTrade',
    meta: { title: 'BTC  Market Trade', icon: 'management', actionid: 333333 },
    children: [
      {
        path: 'MarketTrade',
        component: () => import('@/views/btcmarkettrade/index'),
        name: 'MarketTrade',
        meta: { title: 'BTC Market Trade', icon: 'management', actionid: 3333331 }
      }
      // {
      //   path: 'BtcEstStateManage',
      //   component: () => import('@/views/btcest/manage/est-manage'),
      //   name: 'BtcEstStateManage',
      //   meta: { title: 'BTC Est State Manage', icon: 'management', actionid: 2222222 }
      // }
    ]
  },
  {
    path: '/BtcReport',
    alwaysShow: true,
    component: Layout,
    redirect: '/BtcReport',
    name: 'BtcReport',
    meta: { title: 'BTC Report', icon: 'management', actionid: 444444 },
    children: [
      {
        path: 'UploadReport',
        component: () => import('@/views/btcreport/reportlist'),
        name: 'BtcReportSearchStatistics',
        meta: { title: 'BTC Report', icon: 'management', actionid: 4444441 }
      }
      // {
      //   path: 'BtcEstStateManage',
      //   component: () => import('@/views/btcest/manage/est-manage'),
      //   name: 'BtcEstStateManage',
      //   meta: { title: 'BTC Est State Manage', icon: 'management', actionid: 2222222 }
      // }
    ]
  },
  {
    path: '/BTCVisual',
    alwaysShow: true,
    component: Layout,
    redirect: '/BtcVisual',
    name: 'BtcVisual',
    meta: { title: 'BTC Visual', icon: 'management', actionid: 555555 },
    children: [
      {
        path: 'NoticeManagement',
        component: () => import('@/views/btcvisual/noticeindex'),
        name: 'BtcNoticeManagement',
        meta: { title: 'Notice Management', icon: 'management', actionid: 5555551 }
      }
      // {
      //   path: 'BtcEstStateManage',
      //   component: () => import('@/views/btcest/manage/est-manage'),
      //   name: 'BtcEstStateManage',
      //   meta: { title: 'BTC Est State Manage', icon: 'management', actionid: 2222222 }
      // }
    ]
  }
]

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js